module.exports = __webpack_public_path__ + "static/media/talal.6001a10b.png";